import script from "./auth-email-code.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-email-code.vue?vue&type=script&lang=ts&setup=true"

import "./auth-email-code.vue?vue&type=style&index=0&id=49464bae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49464bae"]])

export default __exports__